export { CandidateCard } from './CandidateCard';
export { default } from './CandidateCard';
